import type { FC } from 'react';
import { ErrorState } from 'src/modules/shared/components/atoms/states/error-state';
import { useI18n } from 'src/modules/shared/hooks/provider-bounded/i18n';
import type { PropertyEditorUnavailableStateProps } from '../../types/property-editor-page.type';

/** Shows inaccessible property states with a return-to-origin action. */
export const PropertyEditorUnavailableState: FC<
  PropertyEditorUnavailableStateProps
> = ({ pageState, onBack }) => {
  const { t } = useI18n();
  const keys =
    pageState === 'forbidden'
      ? ({
          title: 'catalog.properties.permissions.readRequiredTitle',
          description: 'catalog.properties.permissions.readRequiredDescription',
        } as const)
      : ({
          title: 'catalog.properties.editor.loadErrorTitle',
          description: 'catalog.properties.editor.loadErrorDescription',
        } as const);
  return (
    <ErrorState
      title={t(keys.title)}
      description={t(keys.description)}
      onAction={onBack}
      actionContent={t('shared.actions.back')}
    />
  );
};
